import client from 'providers/fetchClient'

export const getPackages = params => client.get('/packages', { params })
export const getPackage = id => client.get(`/packages/${id}`)
export const addNewPrice = (id, value) => client.post(`/packages/${id}/prices`, { value })
